import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { useIsMobile } from 'hooks/useIsMobile';
import { decodeStorage } from 'functions/storageBase64';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import beneficios from './beneficios.module.sass'
import CurrencyFormat from "react-currency-format"
import { ModalLoadingCredit } from 'components/Loading';
import { useWebview } from 'hooks/useWebview';

export function removeText(text){
    let numero = String(text)
    let numero2 = Number( numero.replace(/[^\d]+/g, '') )
    return numero2
}

export function useHomeRedirect(){

    const [login, setLogin] = useState( decodeStorage('session_token') )
    const [credit, setCredit] = useState( decodeStorage('creditoDisponible') )
    const [sears_numero_internet, setSearsNumInternet] = useState( decodeStorage('sears_numero_internet') )
    const [cardending, setCardendigin] = useState( decodeStorage('cardending') )
    const [estadoCredito, setmontoCredito] = useState( decodeStorage('estadoCredito') )
    const [flagAceptoCredito, setFlagAceptoCredito] = useState( decodeStorage('flagAceptoCredito') )

    useEffect(() => {
        setLogin( decodeStorage('session_token') )
        setCredit( decodeStorage('creditoDisponible') )
        setSearsNumInternet( decodeStorage('sears_numero_internet') )
        setCardendigin( decodeStorage('cardending') )
        setmontoCredito( decodeStorage('estadoCredito') )
        setFlagAceptoCredito( decodeStorage('flagAceptoCredito') )
    },[])

    return{
        login,
        credit,
        sears_numero_internet,
        cardending,
        estadoCredito,
        flagAceptoCredito
    }
}
export function useSimulador() {
    const tablaFactores = [
        {mensualidad: 3, factorCredito: 0.376073},
        {mensualidad: 6, factorCredito: 0.205176},
        {mensualidad: 9, factorCredito: 0.148840},
        {mensualidad: 13, factorCredito: 0.114837},
        {mensualidad: 18, factorCredito: 0.094331},
        {mensualidad: 24, factorCredito: 0.081777}
    ]

    const tablaFactoresExt = [
        {mensualidad: 3, factorCredito: 0.398380},
        {mensualidad: 6, factorCredito: 0.226068},
        {mensualidad: 9, factorCredito: 0.170026},
        {mensualidad: 13, factorCredito: 0.136960},
        {mensualidad: 18, factorCredito: 0.117841},
        {mensualidad: 24, factorCredito: 0.106913}
    ]

    const tasa_Interes_CCS = '65%'
    const cat_CCS = '83.3%'
    const tasa_Interes_Otros = '98%'
    const cat_Otros = '120%'

    const totalMeses = tablaFactores.map(rango => rango.mensualidad)

    const [credito, setCredito] = useState(4800)
    const [meses, setMeses] = useState(tablaFactores[0]?.mensualidad)

    const mayorMensualidad = totalMeses[totalMeses?.length - 1]

    let factor = tablaFactores.filter(rango => rango.mensualidad == meses)
    let factorExt = tablaFactoresExt.filter(rango => rango.mensualidad == meses)
    let total = Math.ceil( (removeText(credito) * factor[0]?.factorCredito) * meses)
    let mensualidad = meses === 1 ? Math.ceil(total / meses) : Math.ceil(total / meses)
    
    let totalOtro = Math.ceil( (removeText(credito) * factorExt[0]?.factorCredito) * meses)
    let mensualidadOtro = Math.ceil(totalOtro / meses)

    let ahorro = totalOtro - total

    // console.log('total: ', total)
    // console.log('totalOtro: ', totalOtro)
    
    return {
        credito,
        setCredito,
        meses,
        setMeses,
        mayorMensualidad,
        total,
        totalOtro,
        ahorro,
        mensualidad,
        mensualidadOtro,
        totalMeses,
        tasa_Interes_CCS,
        cat_CCS,
        tasa_Interes_Otros,
        cat_Otros
    }
}

export function First(){
    return(
        <div className={`container ${beneficios?.container}`}>
            <div className={`${beneficios?.fisrtContent}`}>
                <div className={beneficios.logoTitle}></div>
                <h2 className={beneficios.h2}>Sácalo en minutos y compra hoy mismo en nuestra app</h2>
            </div>
        </div>
    )
}
export function Second(){
    return(
        <div className={`container ${beneficios?.container}`}>
            <div className={`${beneficios?.card_type} ${beneficios?.boxShadow}`}>
                <div className={beneficios?.contBene}>
                    <div className={beneficios?.cardBene}>
                        <div className={beneficios?.icon1}></div>
                        <p>Crédito de hasta <strong>$30,000</strong></p>
                    </div>
                    {/*<div className={beneficios?.cardBene}>
                        <div className={beneficios?.icon2}></div>
                        <p><strong>10% de descuento</strong> en tu primera compra</p>
    </div>*/}
                    <div className={beneficios?.cardBene}>
                        <div className={beneficios?.icon3}></div>
                        <p>Compras hasta a <strong>24 meses</strong></p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export function Third(props){
    const {
        typeNav
    } = props 
    return(
        typeNav !== 'app'
            ?
                <div className={`container ${beneficios?.container} ${beneficios?.downloadAppBeneficios}`}>
                    <div className={`${beneficios?.card_type} ${beneficios?.boxShadow}`}>
                        <div className={beneficios?.contDownload}>
                            
                            <div className={beneficios?.textDownload}>
                                <p className={beneficios.titleDownload}>¡Solicítalo desde nuestra app!</p>
                                <p>Descargala escaneando el código QR</p>
                            </div>

                            <div className={beneficios?.cardQR}></div>

                            <div className={beneficios?.contApp}>
                                <div className={beneficios?.claroAppLogo}></div>
                                <div className={beneficios?.contLinks}>
                                    <p>Disponible en:</p>
                                    <div className={beneficios?.contLinksStore}>
                                        <a href="https://play.google.com/store/apps/details?id=com.americamovil.claroshop" className={beneficios?.android}></a>
                                        <a href="https://apps.apple.com/mx/app/claro-shop/id1057314145" className={beneficios?.ios}></a>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            : null
    )
}

export function Cotizador() {

    const { 
        credito, 
        setCredito, 
        meses, 
        setMeses, 
        total,
        totalOtro,
        ahorro,
        mensualidad,
        mensualidadOtro,
        totalMeses,
        tasa_Interes_CCS,
        cat_CCS,
        tasa_Interes_Otros,
        cat_Otros } = useSimulador()


    useEffect(() => {
        // if(Number(removeText(credito)) > 40000){
        //     setTimeout(function(){
        //         setCredito(40000)
        //     },1000)
        // }else if(Number(removeText(credito)) < 100){
        //     setTimeout(function(){
        //         setCredito(100)
        //     },1000)
        // }
    }, [credito, meses, total, mensualidad])

    const [edit, setEdit] = useState()
    useEffect(() => {
        if(edit){
            if(Number(removeText(credito)) > 40000){
                setTimeout(function(){
                    setCredito(40000)
                },1000)
            }else if(Number(removeText(credito)) < 100){
                setTimeout(function(){
                    setCredito(100)
                },1000)
            }
            setEdit(false)
        }
    }, [edit])

    const selectMes = (e) => {
        setMeses(e)
        simulador()
    }

    const editable = (e) => {
        setEdit(true)
    }

    const simulador = () => {
        window.location.href =  `${window.location.origin}${window.location.pathname}#simulador`
    }

    return (
        <div className={`${beneficios?.content_Cotizador} ${beneficios?.container} container`}>
            <span id="simulador"></span>
            <h3 className={`${beneficios?.h3} ${beneficios?.titleCotizador}`}>Somos la <span className={beneficios?.textRed}>mejor opción </span> del mercado</h3>

            <div className={beneficios?.card_Cotizador}>
                <h2 className={`${beneficios?.h2} ${beneficios?.h2Title}`}>Simula tu crédito</h2>
                <div className={beneficios?.card_CotizadorInternal}>
                    <div className={beneficios?.left_Cotizador}>
    
                        <div className={beneficios.cotiza}>
                            <h3 className={beneficios?.h5}>¿Cuánto cuesta lo que quieres comprar?</h3>
                            <div className={beneficios?.contLapiz}>
                                <CurrencyFormat
                                    value={removeText(credito)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={''}
                                    renderText={value => <>
                                        {/* <div className={beneficios?.lapiz} contentEditable="true" onInput={(e) => editable(e.currentTarget.textContent)}>{value}</div> */}
                                        <input type="text" className={beneficios?.inputCotizador} value={value} onBlur={(e) => editable(e)} onChange={(e) => setCredito(e.target.value)} max={40000} min={100} />
                                    </>
                                    } 
                                />
                                <div className={beneficios?.lapiz}></div>
                            </div>
                            <input type="range" className={beneficios?.range} min={100} onChange={(e) => setCredito(e.target.value)} max={40000} value={credito} step="100" />
                        </div>
                        
                        <div>
                            <p className={beneficios?.h5}>¿A cuántos meses quieres pagar?</p>
                            <ul className={beneficios?.cotizadorMeses}>
                                {totalMeses
                                    ? totalMeses?.map((mensualidad, index) => <li key={index} className={`${beneficios?.meses} ${mensualidad === meses ? beneficios?.active : '' }`} onClick={() => selectMes(mensualidad)}>{mensualidad}</li>)
                                    : null
                                }
                            </ul>
                        </div>
                    </div>
                    
                    <div className={beneficios?.right_Cotizador}>
                        <div className={beneficios?.top_Cotizador}>
                            <p className={beneficios?.titleCot}>Compara tus pagos</p>
                            <div className={beneficios?.comparaCotiza}>
                                
                                <div className={`${beneficios?.cotizaTable}`}>
                                    <div className={beneficios?.titleCotiza}></div>
                                    <div className={`${beneficios?.valorCotiza}`}>
                                        <span className={beneficios?.otrosCredito}>Crédito <div className={beneficios?.logo}></div></span>
                                    </div>
                                    <div className={beneficios?.valorCotiza}><span className={beneficios?.otrosCredito}>Otros créditos</span></div>
                                </div>
                                
                                <div className={beneficios?.contCotiza}>
                                    <div className={beneficios?.cotizaTable}>
                                        <div className={beneficios?.titleCotiza}>Tasa de interés anual</div>
                                        <div className={`${beneficios?.valorCotiza} ${beneficios.green}`}>{tasa_Interes_CCS}</div>
                                        <div className={beneficios?.valorCotiza}>{tasa_Interes_Otros}</div>
                                    </div>
                                    <div className={beneficios?.cotizaTable}>
                                        <div className={beneficios?.titleCotiza}>{meses} {meses > 1 ? "pagos" : "pago"} de</div>
                                        <div className={`${beneficios?.valorCotiza} ${beneficios.green}`}>
                                            <CurrencyFormat
                                                value={mensualidad}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                prefix={'$'}
                                                renderText={value => <span>{value}</span>}
                                            />
                                        </div>
                                        <div className={beneficios?.valorCotiza}>
                                            <CurrencyFormat
                                                value={mensualidadOtro}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                prefix={'$'}
                                                renderText={value => <span>{value}</span>}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {ahorro > 0
                                ?
                                    <div className={beneficios?.ahorroCredito}>
                                        <p>Ahorro contra Otros Créditos:</p>
                                        <CurrencyFormat
                                            value={ahorro}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'$'}
                                            renderText={value => <span className={`${beneficios?.green}`}>{value}</span>}
                                        />
                                    </div>
                                : null
                            }
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export function ComoFunciona(props){
    const {
        typeNav,
        login,
        credit
    } = props

    const solicitarCredito = () => {
        window.location.href =  '/credito-claroshop/comenzar-solicitud'
    }

    return(
        <div className={`${beneficios?.content_ComoFunciona} container`}>
            {/*typeNav !== 'app'
                ?
                    <div className={beneficios?.center_ComoFunciona}>
                        <div className={`btn rojo ${beneficios?.btn} ${beneficios?.btn_red}`} onClick={solicitarCredito} >Comenzar solicitud</div>
                    </div>
                : null
    */}
            <div className={`${beneficios?.card_ComoFunciona} container`}>
                <div className={beneficios?.right_ComoFunciona}>
                    <h2 className={beneficios?.h3}>¿Cómo funciona crédito <span className={beneficios?.logo}></span>?</h2>
                </div>
                <div className={beneficios?.left_ComoFunciona}>
                    <ul className={beneficios?.stepUl}>
                        <li className={beneficios?.stepLi}>Solicita tu crédito (3 minutos)</li>
                        <li className={beneficios?.stepLi}>Obtén respuesta en minutos</li>
                        <li className={beneficios?.stepLi}>Elige el producto</li>
                        <li className={beneficios?.stepLi}>Elige pagar con Crédito <span className={beneficios?.logo}></span></li>
                        <li className={beneficios?.stepLi}>Selecciona mensualidades a pagar</li>
                        <li className={beneficios?.stepLi}>¡Listo! Disfruta tu producto</li>
                    </ul>
                </div>
                
            </div>
        </div>
    )
}

export function AdministraCredito(){
    return(
        <div className={`${beneficios?.content_AdministraCredito} container`}>

            <div className={`${beneficios?.inf_AdministraCredito} ${beneficios?.desktop}`}>
                <div className={beneficios?.left_AdministraCredito}>
                    <img src="/credito-claroshop/img/beneficios/cell.png" alt="¿Cómo compro con mi crédito?" />
                </div>
                <div className={beneficios?.right_AdministraCredito}>
                    <h3 className={`${beneficios?.h3}`}>Administra tu crédito desde <span className={beneficios?.textRed}>nuestra app</span></h3>
                    <p>Paga tu mensualidad con tu <span className={beneficios?.strong}>tarjeta de crédito o débito o mediante SPEI.</span></p>
                </div>
            </div>

            <div className={`${beneficios?.inf_AdministraCredito} ${beneficios?.movil}`}>
                <div className={beneficios?.left_AdministraCredito}>
                    <h3 className={`${beneficios?.h3}`}>Administra tu crédito desde <span className={beneficios?.textRed}>nuestra app</span></h3>
                    <img src="/credito-claroshop/img/beneficios/cell.png" alt="¿Cómo compro con mi crédito?" />
                </div>
                <div className={beneficios?.right_AdministraCredito}>
                    <p>Paga tu mensualidad con tu <span className={beneficios?.strong}>tarjeta de crédito o débito o mediante SPEI.</span></p>

                </div>
            </div>
            
        </div>
    )
}


export function DescargaApp(props){
    const {
        typeNav,
        typeMovile
    } = props
    
    return(
        typeNav !== 'app'
            ?
                <div className={`container ${beneficios?.container}`}>
                    <div>
                        <div className={beneficios?.descargaApp}>
                            <p>Descarga nuestra app</p>
                            <div className={beneficios?.contApp}>
                                <div className={beneficios?.claroAppLogo}></div>
                                <div className={beneficios?.contLinks}>
                                    <div className={beneficios?.contLinksStore}>
                                        {typeMovile !== 'iOS'
                                            ?
                                                <a href="https://play.google.com/store/apps/details?id=com.americamovil.claroshop" className={beneficios?.android1}></a>
                                            : null
                                        }
                                        {typeMovile !== 'android'
                                            ?
                                                <a href="https://apps.apple.com/mx/app/claro-shop/id1057314145" className={beneficios?.ios1}></a>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            : null
    )
}

export function SolicitudApp(props){
    const {
        typeNav,
        login
    } = props

    const solicitarCredito = () => {
        window.location.href =  '/credito-claroshop/comenzar-solicitud'
    }

    const ingesarCredito = () => {
        window.location.href =  '/credito-claroshop/home/consultar-saldo'
    }
    
    return(
        typeNav !== 'app'
            ?
                <div className={`container ${beneficios?.container} ${beneficios?.contSolicitudApp}`}>
                    <div className={`btn rojo ${beneficios?.btn} ${beneficios?.btn_red}`} onClick={solicitarCredito} >Comenzar solicitud</div>
                    {!login
                        ?
                            <div className={`btn blanco ${beneficios?.btn} ${beneficios?.btn_white}`} onClick={ingesarCredito} >Iniciar sesión</div>
                        : null
                    }
                </div>
            : null
    )
}

export function Beneficios() {

    const { isMobile } = useIsMobile();
    const [loading, setLoading] = useState(true)

    const { typeNav, typeMovile } = useWebview()

    const {        
        login,
        credit,
        sears_numero_internet,
        cardending,
        estadoCredito,
        flagAceptoCredito
    } = useHomeRedirect()

    useEffect(() => {

        console.log('flagAceptoCredito: ', flagAceptoCredito)
        console.log('credit: ', credit)
        if(credit && login || flagAceptoCredito === 200){
            setTimeout(function(){
                window.location.href = `${BASE_PATH}${SUB_DIRECTORY}home/consultar-saldo`
            },500)
        }
        else{
            setLoading(false)
        }
    },[login, credit])

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Benefits landing  Credit-Page');
        window.ineum('meta', 'portal', 'Credito CS');
    }, [])

    const structData = `{
        "@context": "http://schema.org/",
        "@type": "Product",
        "name": "Crédito Claroshop",
        "description": "Paga hasta en 24 meses y obtén 10% de descuento en tu primera compra",
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "25592 ",
          "bestRating": "5",
          "worstRating": "1"
        },
        "image": "https://www.claroshop.com/c/algolia/images/claro-shop-1.jpeg",
        "brand": { "@type": "Thing", "name": "Crédito Claroshop" }
    }`
    
    return (
        <>
            <Helmet>
                <title>{'Crédito Claroshop: Paga hasta 24 meses  + 10% de descuento'}</title>
                <link rel="canonical" href={`https://www.claroshop.com/credito-claroshop/beneficios`} />

                <meta name="Description" content={`Compra sin tarjeta y paga hasta en 24 meses con Crédito Claroshop. Sácalo en minutos y obtén 10% de descuento en tu primera compra. Crédito hasta $30,000MXN`} />
            
                <meta property="og:locale" content="es_MX" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Crédito Claroshop: Paga hasta 24 meses  + 10% de descuento" />
                <meta property="og:description" content="Compra sin tarjeta y paga hasta en 24 meses con Crédito Claroshop. Sácalo en minutos y obtén 10% de descuento en tu primera compra. Crédito hasta $30,000MXN." />
                <meta property="og:url" content="https://www.claroshop.com/credito-claroshop/beneficios" />
                <meta property="og:site_name" content="Claroshop" />
                <meta property="og:image" content="https://www.claroshop.com/c/credito/credito-og.jpg" />
                <meta property="og:image:secure_url" content="https://www.claroshop.com/c/credito/credito-og.jpg" />
                <meta property="og:image:width" content="1500" />
                <meta property="og:image:height" content="700" />
                <meta property="og:image:alt" content="Claroshop" />
                <meta property="og:image:type" content="image/png" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Crédito Claroshop: Paga hasta 24 meses  + 10% de descuento" />
                <meta name="twitter:description" content="Compra sin tarjeta y paga hasta en 24 meses con Crédito Claroshop. Sácalo en minutos y obtén 10% de descuento en tu primera compra. Crédito hasta $30,000MXN." />
                <meta name="twitter:image" content="https://www.claroshop.com/c/credito/credito-og.jpg" />
                <meta name="twitter:label2" content="Productos" />
                <meta name="twitter:data2" content="567" />

                <meta name="robots" content="follow, index" />

                <script type="application/ld+json">
                    { structData }
                </script>
            </Helmet>
            {loading && <ModalLoadingCredit />}
            <div className={isMobile === "desktop" ? "" : "homeMobile"}>
                {isMobile === "desktop"
                    ? <Header type="complete" />
                    : <HeaderMobileCredito title={"Crédito Claroshop"} type="backFull" goBack={"homeClaro"}/>
                }
                <main>
                    <First />
                    <Second />
                    <Third typeNav={typeNav} typeMovile={typeMovile} />
                    <Cotizador />
                    <ComoFunciona typeNav={typeNav} login={login} credit={credit} />
                    <AdministraCredito />
                    <DescargaApp typeNav={typeNav} typeMovile={typeMovile} />
                    {/*<SolicitudApp typeNav={typeNav} login={login} />*/}
                </main>
                <Footer type="complete" />
            </div>
        </>
    );
}